import { Component, EventEmitter, Input, Output, OnDestroy, Attribute } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DialogImportUsersComponent } from './dialog-import-users/dialog-import-users.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'button-import-users',
    templateUrl: './button-import-users.html',
    styleUrls: ['./button-import-users.scss']
})
export class ButtonImportUsersComponent implements OnDestroy {
    @Output() uploadDone = new EventEmitter();

    public loading = false;

    public get propagateClick(): 'true' | 'false' {
        return this._propagateClick;
    }
    public set propagateClick(value: 'true' | 'false') {
        this._propagateClick = value;
    }

    private _destroyed$ = new Subject();

    constructor(
        private _dialog: MatDialog,
        @Attribute('propagateClick') private _propagateClick: 'true' | 'false' = 'true'
    ) {
    }

    ngOnDestroy() {
        this._dialog.closeAll();
        this._destroyed$.next();
        this._destroyed$.complete();
        this._destroyed$.unsubscribe();
    }

    openDialog() {
        const dialogConfig = new MatDialogConfig();
        const dialogRef = this._dialog.open(DialogImportUsersComponent, dialogConfig);
        dialogRef.componentInstance.onLoading.pipe(
            takeUntil(this._destroyed$)
        ).subscribe(
            (loading: boolean) => {
                this.loading = loading;
            }
        );

        dialogRef.componentInstance.onUploadDone.pipe(
            takeUntil(this._destroyed$)
        ).subscribe(
            () => {
                this.uploadDone.emit(true);
            }
        );
    }
}
